
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { WifiOff, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface NetworkErrorProps {
  onRetry?: () => void;
}

export function NetworkError({ onRetry }: NetworkErrorProps) {
  return (
    <Alert className="mt-6 mx-auto max-w-3xl bg-amber-900/20 border-amber-800">
      <WifiOff className="h-4 w-4" />
      <AlertTitle>Network Connection Issue</AlertTitle>
      <AlertDescription>
        <p className="mb-2">You appear to be offline. Please check your internet connection and try again.</p>
        {onRetry && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onRetry}
            className="mt-2 bg-amber-900/30 hover:bg-amber-800/50 border-amber-700"
          >
            <RefreshCw className="mr-2 h-3 w-3" />
            Retry Connection
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
}
